import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { faker } from '@faker-js/faker';
import axios from 'axios';

import back from "../assets/icons/back-arrow.png"
import logo from '../moodmealslogo.png';
import A1 from "../assets/icons/1.png";
import A2 from "../assets/icons/2.png";
import A3 from "../assets/icons/3.png";
import A4 from "../assets/icons/4.png";
import A5 from "../assets/icons/5.png";
import A6 from "../assets/icons/6.png";
import A7 from "../assets/icons/7.png";
import A8 from "../assets/icons/8.png";
import A9 from "../assets/icons/9.png";
import A10 from "../assets/icons/10.png";

import Modal from './ErrorModal';
import '../styles/Login&RegisterPage.css';

const RegisterPage=()=>{
    
    const getRandomAvatar=()=>{
        const Icons=[A1,A2,A3,A4,A5,A6,A7,A8,A9,A10];
        return Icons[Math.floor(Math.random()*Icons.length)];
    };
    const [newUser,setNewUser]=useState({
        avatar: getRandomAvatar(),
        firstname:faker.person.firstName(),
        lastname:faker.person.lastName(),
        gender:'',
        email:faker.internet.email(),
        contact_num:faker.phone.number({style:'international'}),
        password:'',
        terms_privacy:true,
        consent:true
    });
    const [repw,setRePw]=useState("");
    
    const [users,setUsers]=useState([]);
    const [message,setMessage]=useState('');
    const [isLoading,setIsLoading]=useState(true);
    const [showModal,setShowModal]=useState(false);
    const [registrationSuccess, setRegistrationSuccess]=useState(false);
    const navigate = useNavigate();

    const changeRePw=(text)=>{
        setRePw(text);
    }
    
    useEffect(()=>{
        setTimeout(()=>{
          setIsLoading(false);
        },2000);
    },[]);

    const handleSubmit=(e)=>{
        e.preventDefault();
        axios.get(`/api/getUsers`,{withCredentials: true})
        .then(res=>{
            setUsers(res.data.users);
            if (newUser.password!==repw) {
                setMessage("Password do not match. Please try again.");
                setShowModal(true);
                return;
            }else if(users.find(user=>user.email===newUser.email)){
                setMessage("Email already exists. Please try again.");
                setShowModal(true);
                return;
            }else if(users.find(user=>user.contact_num===newUser.contact_num)){
                setMessage("Phone number already exists. Please try again.");
                setShowModal(true);
                return;
            }
            axios.post(`/api/users/new`,newUser,{withCredentials: true})
            .then(res=>{
                setNewUser({
                    avatar:'',
                    firstname:'',
                    lastname:'',
                    gender:'',
                    email:'',
                    contact_num:'',
                    password:'',
                    terms_privacy:'',
                    consent:''
                })
                setMessage("Registration successful!");
                setShowModal(true);
                setRegistrationSuccess(true);
            })
            .catch(error=>{
                console.error("Error registering user:",error);
                setMessage("Registration failed. Please try again.");
                setShowModal(true);
            });
        })
        .catch(err=>{
            console.error('Something went wrong',err);
        })
    };
    
    const closeModal=()=>{
        setShowModal(false);
        if(registrationSuccess){
            navigate('/login');
        }
    };

    return (
        <>
            {isLoading?(
                <div className="loadingContainer">
                    <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
                </div>
            ):(
            <>
                <div className="register-bg-wrapper">
                    <div className="register-flex"> 
                        <header className="register-header">
                            <div className="register-back">
                                <Link to="/"><img src={back} className="register-back-btn" alt="Back"/> Back</Link>
                            </div>
                            <div className="register-moodmeals-logo">
                                <img src={logo} alt="logo"/>
                            </div>
                        </header>
                        <div className="register-wrapper">
                            <div className="register">
                                <h2>Register</h2>
                                <form method="post" onSubmit={handleSubmit}>
                                    <input type="hidden" name="avatar" value={newUser.avatar} onChange={(e)=>setNewUser({...newUser, avatar: e.target.value})}/>
                                    <div className="register-inputbox">
                                        <input type="text" name="firstname" value={newUser.firstname} onChange={(e)=>setNewUser({...newUser, firstname: e.target.value})} maxLength={35} required="required"/>
                                        <span>First Name</span>
                                        <i></i>
                                        <ii className='bx bxs-user'></ii>
                                    </div>
                                    <div className="register-inputbox">
                                        <input type="text" name="lastname" value={newUser.lastname} onChange={(e)=>setNewUser({...newUser, lastname: e.target.value})} maxLength={35} required="required"/>
                                        <span>Last Name</span>
                                        <i></i>
                                        <ii className='bx bxs-user'></ii>
                                    </div>
                                    <div className="register-inputbox">
                                        <select name="user-gender" value={newUser.gender} onChange={(e)=>setNewUser({...newUser, gender: e.target.value})} title="User Gender" required="required">
                                            <option value="" selected></option>
                                            <option>Male</option>
                                            <option>Female</option>
                                        </select>
                                        <span>Gender</span>
                                        <i></i>
                                        <ii className='bx bx-male-female'></ii>
                                    </div>
                                    <div className="register-inputbox">
                                        <input type="email" name="regemail" value={newUser.email} onChange={(e)=>setNewUser({...newUser, email: e.target.value})} maxLength={30} required="required"/>
                                        <span>Email Address</span>
                                        <i></i>
                                        <ii className='bx bxs-envelope' ></ii>
                                    </div>
                                    <div className="register-inputbox">
                                        <input type="text" id="phoneno" name="regpn" value={newUser.contact_num} onChange={(e)=>setNewUser({...newUser, contact_num: e.target.value})} minLength={11} maxLength={12} required="required"/>
                                        <span>Phone No.</span>
                                        <i></i>
                                        <ii className='bx bxs-phone'></ii>
                                    </div>
                                    <div className="register-inputbox">
                                        <input type="password" name="regpw" value={newUser.password} onChange={(e)=>setNewUser({...newUser, password: e.target.value})} minLength={6} maxLength={20} required="required"/>
                                        <span>Your Password</span>
                                        <i></i>
                                        <ii className='bx bxs-lock-alt'></ii>
                                    </div>
                                    <div className="register-inputbox">
                                        <input type="password" name="confirmregpw" onChange={(e)=>{changeRePw(e.target.value)}} minLength={6} maxLength={20} required="required"/>
                                        <span>Confirm Password</span>
                                        <i></i>
                                        <ii className='bx bxs-lock-alt'></ii>
                                    </div>
                                    <div className="term-privacy">
                                        <div className="terms-of-use">
                                            <input type="checkbox" value={newUser.terms_privacy} onChange={(e)=>setNewUser({...newUser, terms_privacy: e.target.value})} required="required"/>
                                            <span>I agree to the <a href="/">Terms of Use</a> and understand that my information will be used as described on this page and the MoodMeals <a href="/">Privacy Policy</a>.</span>
                                        </div>
                                        <div className="consent">
                                            <input type="checkbox" value={newUser.consent} onChange={(e)=>setNewUser({...newUser, consent: e.target.value})} required="required"/>
                                            <span>I consent to receive promotional offers and marketing information from MoodMeals Philippines and its affiliates as stated on the Privacy Policy.</span>
                                        </div>
                                    </div>
                                    <div className="register-links">
                                        <span>Already have an account?</span>
                                        <Link to="/login" id="loginbtn2" className="loginbtn2">Login</Link>
                                    </div>
                                    <input id="RegisterMo" type="submit" value="Register"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="register-bg-wrapper2"></div>
                {showModal&&<Modal message={message} onClose={closeModal}/>}
            </>
            )}
        </>
    )
}

export default RegisterPage;